import React from "react";
import video from "../assets/SiddhiGanapathaiVideo.mp4";

const VideoPage = () => {
  return (
    <div className="bg-gray-100">
      <video
        width="95%"
        height="80%"
        controls
        autoPlay
        muted
        loop 
        className="mx-auto rounded-[10px]"
      >
        <source src={video} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoPage;
